import React from 'react';
import { ArrowRight, Mail, Instagram, Youtube } from 'lucide-react';
import { Button } from './ui/button';
import { influencerData } from '../mock';

const FinalCTA = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-[#0F172A] to-[#0A0F0D] relative overflow-hidden">
      {/* Background Glow Effect */}
      <div className="absolute inset-0 bg-[#22C55E]/5 blur-3xl"></div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="space-y-8 animate-fade-in-up">
          {/* Heading */}
          <h2 className="text-4xl md:text-6xl font-bold text-white leading-tight">
            Let's Build Your Next
            <span className="block text-[#22C55E] mt-2">
              High-Converting Campaign
            </span>
          </h2>
          
          {/* Subheading */}
          <p className="text-xl text-[#94A3B8] max-w-2xl mx-auto">
            Ready to reach millions of engaged fitness enthusiasts? Let's create content that converts.
          </p>
          
          {/* CTA Button */}
          <div className="pt-4">
            <Button 
              className="bg-[#16A34A] hover:bg-[#22C55E] text-white px-10 py-7 text-xl font-semibold rounded-lg shadow-lg shadow-[#22C55E]/40 hover:shadow-[#22C55E]/60 transition-all duration-300 hover:scale-105 glow-button-strong"
            >
              <Mail className="mr-2 h-6 w-6" />
              Start Collaboration
              <ArrowRight className="ml-2 h-6 w-6" />
            </Button>
          </div>
          
          {/* Contact Info */}
          <div className="pt-8">
            <p className="text-[#94A3B8] mb-4">or reach out directly</p>
            <a 
              href={`mailto:${influencerData.email}`}
              className="text-[#22C55E] hover:text-[#4ADE80] font-semibold text-lg transition-colors duration-300"
            >
              {influencerData.email}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

const Footer = () => {
  return (
    <footer className="bg-[#0A0F0D] border-t border-[#22C55E]/10 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-2">{influencerData.name}</h3>
            <p className="text-[#94A3B8] text-sm">Fitness Influencer & Brand Partner</p>
          </div>
          
          {/* Social Links */}
          <div className="flex gap-6">
            <a 
              href="#" 
              className="flex items-center gap-2 text-[#94A3B8] hover:text-[#22C55E] transition-colors duration-300"
            >
              <Instagram className="h-5 w-5" />
              <span className="text-sm">{influencerData.instagram}</span>
            </a>
            <a 
              href="#" 
              className="flex items-center gap-2 text-[#94A3B8] hover:text-[#22C55E] transition-colors duration-300"
            >
              <Youtube className="h-5 w-5" />
              <span className="text-sm">{influencerData.youtube}</span>
            </a>
          </div>
          
          {/* Copyright */}
          <div className="text-[#94A3B8] text-sm">
            © 2025 {influencerData.name}. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export { FinalCTA, Footer };